(function () {
  if (window.__ncNoticeMailFormInit) {
    return;
  }
  window.__ncNoticeMailFormInit = true;

  var KLAVIYO_REVISION = '2024-10-15';
  var SUBSCRIBE_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' || !form.matches('form.notice-mail')) {
      return;
    }
    event.preventDefault();
    handleSubmit(form);
  });

  function getStatusElement(form) {
    var parent = form.parentNode;
    return parent ? parent.querySelector('[data-klaviyo-status]') : null;
  }

  function setStatus(form, message, type) {
    var status = getStatusElement(form);
    if (!status) {
      return;
    }
    status.textContent = message || '';
    status.hidden = !message;
    status.classList.remove('notice-mail__status--success', 'notice-mail__status--error');
    if (type) {
      status.classList.add('notice-mail__status--' + type);
    }
  }

  function handleSubmit(form) {
    var companyId = form.getAttribute('data-company-id');
    var listId = form.getAttribute('data-list-id');
    var emailInput = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var email = emailInput ? emailInput.value.trim() : '';

    var successMessage = form.getAttribute('data-success-message') || 'Thank you for signing up.';
    var errorMessage = form.getAttribute('data-error-message') || 'Something went wrong. Please try again later.';
    var invalidMessage = form.getAttribute('data-invalid-message') || 'Please enter a valid email address.';

    if (!email || (emailInput && !emailInput.checkValidity())) {
      setStatus(form, invalidMessage, 'error');
      if (emailInput) {
        emailInput.focus();
      }
      return;
    }

    if (!companyId || !listId) {
      setStatus(form, errorMessage, 'error');
      return;
    }

    if (button) {
      button.disabled = true;
    }
    setStatus(form, '', null);

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: listId }
          }
        }
      }
    };

    fetch(SUBSCRIBE_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.ok) {
          form.reset();
          setStatus(form, successMessage, 'success');
        } else {
          setStatus(form, errorMessage, 'error');
        }
      })
      .catch(function () {
        setStatus(form, errorMessage, 'error');
      })
      .then(function () {
        if (button) {
          button.disabled = false;
        }
      });
  }
})();
